export default __webpack_public_path__ + "47e9d36c6aacb5d767353d070ea59589.svg";